<template>
  <section>
    <a class="anchor" id="schedule"></a>
    <h2 class="title">{{$t('trainingSchedule')}}</h2>
    <p>{{$t('trainingScheduleDesc')}}</p>
    <br>
    <div class="parenttable">
    <b-table id="schedule-table" :data="data" :columns="columns" :mobile-cards="false">
    </b-table>
    </div>
    <br>
    <h2 class="title">{{$t('eventSchedule')}}</h2>
    <p>{{$t('eventScheduleDesc_1')}}</p>
    <br>
    <ul class="ul">
      <li>{{$t('esli_1')}}</li>
      <li>{{$t('esli_2')}}</li>
      <li>{{$t('esli_3')}}</li>
      <li>{{$t('esli_4')}}</li>
      <li>{{$t('esli_5')}}</li>
      <li>{{$t('esli_6')}}</li>
      <li>{{$t('esli_7')}}</li>
      <li>{{$t('esli_8')}}</li>
      </ul>
    <br>
    <p>{{$t('eventScheduleDesc_2')}}</p>
    <br><br>
    <div class="parent-grid">
    <!-- <a class="twitter-timeline" data-height="600" href="https://twitter.com/uecst?ref_src=twsrc%5Etfw">Tweets by uecst</a> -->
    <img class="deco-up" src="../assets/SVG/ellipse-small.svg">
    </div>
  </section>
</template>

<script>

 export default {
    name: "Schedule",
    computed: {
        data: function() {
            return [
                { 'month': '5~8', 'day': this.$t('tue')+','+this.$t('thu')+','+this.$t('fri'), period: '16:30～18:30', 'content': this.$t('swimming'), 'place': this.$t('uecPool') },
                { 'month': '9', 'day': '', 'period': 'OFF', 'content': '', 'place': '' },
                { 'month': '10~4', 'day': this.$t('mon')+'~'+this.$t('fri'), 'period': '7:30~9:30(8:30)', 'content': this.$t('swimmingMorning'), 'place': '' },
                { 'month': '', 'day': this.$t('tue')+','+this.$t('fri'), 'period': '16:30~18:00', 'content': this.$t('workout'), 'place': this.$t('uecGymOrPool') },
                { 'month': '', 'day': this.$t('fri'), 'period': '18:30~20:30', 'content': this.$t('swimmingEvening'), 'place': this.$t('choufuGymPool') },
                
            ];
        },
        columns: function() {
          return [
                {
                    field: 'month',
                    label: this.$t('month'),
                    width: '40',
                    centered: true
                },
                {
                    field: 'day',
                    label: this.$t('day'),
                    width: '70',
                    centered: true
                },
                {
                    field: 'period',
                    label: this.$t('period'),
                    centered: true
                },
                {
                    field: 'content',
                    label: this.$t('content'),
                    width: '300',
                    centered: true
                },
                {
                    field: 'place',
                    label: this.$t('place'),
                    width: '300',
                    centered: true
                }
            ];
        }
    }
}
</script>

<style scoped>
.parenttable {
  overflow-x: auto;
}
#schedule-table {
  min-width: 500px;

}
.center {
  text-align: center;
}
.parent-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
}
h2 {
    font-size: 48px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding-bottom: 20px;
    padding-top: 30px;
    color: #005080;
}
p {
  text-align: left;
}
section {
    padding: 0px 10% 50px 10%;
  }
  .deco-up {
    width: 100px;
    position: absolute;
    top: -75px;
    right: 100px;
    z-index: -100;
  }
@media only screen and (max-width: 1500px){
  .deco-up {
      width: 50px !important;
      right: 50px !important; 
  }
  .parent-grid {
    display: block !important;
  }
}

   
</style>